(() => {
  const widget = document.querySelector('#judgeme_product_reviews.rnl-client-reviews');
  if (!widget) return;
  const label = widget.dataset.reviewHeading;
  const normalizeHeading = () => {
    const heading = widget.querySelector('.jdgm-rev-widg__title');
    if (heading && label && heading.textContent.trim() !== label) heading.textContent = label;
  };
  const summary = document.querySelector('.rl-review-summary');
  const prepareSummary = () => {
    const badge = summary && summary.querySelector('.jdgm-preview-badge');
    if (!badge) return;
    badge.setAttribute('role', 'link');
    badge.setAttribute('tabindex', '0');
    badge.setAttribute('aria-label', 'Read Client Reviews');
  };
  const showReviews = event => {
    if (!event.target.closest('.jdgm-preview-badge')) return;
    if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    widget.scrollIntoView({behavior: 'smooth', block: 'start'});
  };
  if (summary) {
    summary.addEventListener('click', showReviews, true);
    summary.addEventListener('keydown', showReviews, true);
    new MutationObserver(prepareSummary).observe(summary, {childList: true, subtree: true});
    prepareSummary();
  }
  normalizeHeading();
  new MutationObserver(normalizeHeading).observe(widget, {childList: true, subtree: true});
})();
